import React from 'react'
import Navbar from '../UI/Navbar'
import { Outlet } from 'react-router-dom'
import Footer from '../UI/Footer'

const NavFot = () => {
  return (
    <div>
    <div className="">
      <Navbar/>
    </div>
    <div className="">
      <Outlet />
    </div>
    <div className="">
      
      <Footer/>
    </div>
  </div>
  )
}

export default NavFot